import { render } from "./NotesList.vue?vue&type=template&id=1d240858"
import script from "./NotesList.vue?vue&type=script&lang=js"
export * from "./NotesList.vue?vue&type=script&lang=js"

import "./NotesList.vue?vue&type=style&index=0&id=1d240858&lang=less"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__